export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  date: string;
  image: string;
  content: string;
}

export const newsCategories = [
  "电影动态",
  "剧集更新",
  "明星八卦",
  "行业观察",
  "综艺热点",
];

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "科幻巨制《深空回响》定档暑期，先导预告点燃期待",
    summary:
      "由顾承宇执导的科幻电影《深空回响》正式宣布定档暑期档，最新先导预告片上线后迅速登上热搜，宏大视效引发观众热议。",
    category: "电影动态",
    date: "2025-06-18",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20cinema%20news%20photo%2C%20a%20futuristic%20spaceship%20hologram%20displayed%20in%20a%20warm%20lit%20exhibition%20hall%2C%20modern%20entertainment%20media%20style%2C%20orange%20and%20amber%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n1&orientation=landscape",
    content:
      "备受期待的科幻电影《深空回响》今日正式宣布定档暑期档。影片由导演顾承宇执导，陈砚舟、林知夏领衔主演，讲述一支深空探测队在木星轨道收到神秘信号的故事。最新发布的先导预告中，宏大的宇宙场景与紧张的叙事节奏引发了观众的强烈好奇，相关话题迅速登上热搜榜单。制片方表示，影片在视觉特效上投入了大量精力，力求为观众带来沉浸式的观影体验。",
  },
  {
    id: "n2",
    title: "《悬案档案》口碑持续发酵，登顶本周剧集热度榜",
    summary:
      "悬疑剧《悬案档案》开播以来口碑一路走高，凭借扎实的剧本与演员的精彩表演，稳居本周剧集热度榜首位。",
    category: "剧集更新",
    date: "2025-06-16",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20TV%20drama%20news%20photo%2C%20a%20dim%20study%20with%20stacked%20old%20case%20files%20and%20a%20desk%20lamp%2C%20mysterious%20atmospheric%20mood%2C%20warm%20orange%20light%20against%20deep%20shadow%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n2&orientation=landscape",
    content:
      "悬疑剧《悬案档案》自开播以来口碑持续发酵，凭借层层递进的案件设计与演员细腻的表演，迅速攀升至本周剧集热度榜首位。该剧以一个专门重启冷案的特别小组为主线，每一个案件背后都藏着一段等待被听见的人生。观众纷纷表示，剧集在悬念铺陈与情感刻画之间取得了很好的平衡，是近期不可多得的悬疑佳作。",
  },
  {
    id: "n3",
    title: "音乐综艺《星光舞台》新一季开播，首期舞台惊艳全场",
    summary:
      "全新一季《星光舞台》正式开播，首期节目中多位新生代歌手带来高水准合作舞台，节目相关话题迅速登上社交平台热搜。",
    category: "综艺热点",
    date: "2025-06-14",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20music%20show%20news%20photo%2C%20a%20grand%20concert%20stage%20with%20glowing%20orange%20spotlights%20and%20an%20empty%20microphone%2C%20energetic%20vibrant%20mood%2C%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n3&orientation=landscape",
    content:
      "音乐竞演综艺《星光舞台》新一季正式开播，首期节目集结多位实力派新生代歌手，带来多场高水准的合作舞台。节目以纯粹的现场演唱为核心，弱化竞技、突出音乐本身，收获了不少观众的认可。开播当晚，节目相关话题迅速登上社交平台热搜，多个舞台片段被网友反复观看，讨论度居高不下。",
  },
  {
    id: "n4",
    title: "历史大剧《宫廷风云》收官，收视与口碑双丰收",
    summary:
      "长篇历史剧《宫廷风云》日前圆满收官，全剧收视稳居同时段前列，观众对剧中人物塑造与服化道细节给予高度评价。",
    category: "剧集更新",
    date: "2025-06-12",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20historical%20drama%20news%20photo%2C%20ancient%20Chinese%20palace%20corridor%20with%20warm%20lantern%20light%20at%20dusk%2C%20elegant%20regal%20mood%2C%20golden%20orange%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n4&orientation=landscape",
    content:
      "长篇历史剧《宫廷风云》日前迎来收官。全剧播出期间收视稳居同时段前列，网络播放量与讨论热度持续走高。观众普遍认为，该剧在人物塑造上颇为用心，主角在宫廷斗争中坚守道义的成长线令人动容；此外，考究的服化道与场景设计也为剧集增色不少。不少观众留言表示，希望未来能看到更多这样用心的历史题材作品。",
  },
  {
    id: "n5",
    title: "暑期档前瞻：多部类型片扎堆上映，市场竞争白热化",
    summary:
      "随着暑期档临近，多部科幻、动作与合家欢影片相继定档，业内人士预测今年暑期档竞争将格外激烈。",
    category: "电影动态",
    date: "2025-06-10",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20film%20market%20news%20photo%2C%20a%20row%20of%20illuminated%20movie%20theater%20marquee%20lights%20at%20night%2C%20urban%20entertainment%20mood%2C%20warm%20orange%20and%20amber%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n5&orientation=landscape",
    content:
      "随着暑期档临近，电影市场进入白热化竞争阶段。目前已有多部科幻、动作与合家欢类型影片相继定档，其中不乏备受期待的头部作品。业内人士分析认为，今年暑期档影片类型更加多元，观众的选择空间更大，但同时也意味着单部影片面临的竞争压力上升。最终谁能脱颖而出，还需交由市场和观众检验。",
  },
  {
    id: "n6",
    title: "文明考古题材受关注，《山海秘语》带动探险片讨论",
    summary:
      "冒险科幻电影《山海秘语》上映后引发对文明考古题材的广泛讨论，影片对远古秘境的想象成为观众津津乐道的话题。",
    category: "电影动态",
    date: "2025-06-08",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20adventure%20film%20news%20photo%2C%20a%20mystic%20karst%20cave%20interior%20with%20glowing%20amber%20crystal%20formations%2C%20atmospheric%20awe%20mood%2C%20warm%20orange%20and%20teal%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n6&orientation=landscape",
    content:
      "冒险科幻电影《山海秘语》上映后，带动了一波关于文明考古题材的讨论热潮。影片将地质学、远古生物与东方奇幻想象相结合，构建出一个神秘的山海世界。许多观众表示，影片对未知文明的大胆想象令人印象深刻，也激发了自己对考古与历史话题的兴趣。影评人认为，这类将硬核设定与冒险叙事结合的尝试，为国产类型片提供了新的思路。",
  },
  {
    id: "n7",
    title: "青年演员林知夏新剧官宣，搭档实力派引期待",
    summary: "青年演员林知夏确认出演都市剧《都市情缘》女主角，将与实力派男演员搭档，消息公布后引发粉丝热议。",
    category: "明星八卦",
    date: "2025-06-06",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20celebrity%20news%20photo%2C%20an%20elegant%20bright%20backstage%20dressing%20room%20mirror%20with%20warm%20bulbs%2C%20glamorous%20soft%20mood%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n7&orientation=landscape",
    content:
      "青年演员林知夏日前确认将出演都市爱情剧《都市情缘》的女主角，与一位实力派男演员搭档。消息公布后，相关话题迅速登上社交平台热搜，粉丝们纷纷表达了对新剧的期待。据悉，该剧聚焦都市年轻人的生活与情感，预计于下半年开机，制作方表示会在剧本打磨上投入更多时间，力求呈现真实而有温度的作品。",
  },
  {
    id: "n8",
    title: "行业观察：短视频冲击下，长剧集如何留住观众",
    summary:
      "在短视频内容快速增长的背景下，长剧集如何提升节奏与叙事效率、留住观众注意力，成为业内探讨的焦点话题。",
    category: "行业观察",
    date: "2025-06-04",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20media%20industry%20news%20photo%2C%20a%20modern%20streaming%20dashboard%20displayed%20on%20a%20screen%20in%20a%20warm%20lit%20studio%2C%20analytical%20professional%20mood%2C%20orange%20and%20slate%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n8&orientation=landscape",
    content:
      "在短视频内容快速增长的背景下，长剧集如何留住观众成为业内热议的话题。多位从业者认为，观众并非失去了对长内容的耐心，而是对节奏与叙事效率提出了更高要求。合理设置钩子、减少无效铺垫、在人物塑造上投入更多笔墨，成为创作者共同的方向。也有观点指出，长剧集的核心优势在于情感的深度与人物关系的复杂，这是短内容难以替代的。",
  },
  {
    id: "n9",
    title: "悬疑剧扎堆上线，精品化成为竞争关键",
    summary:
      "近期多部悬疑题材剧集陆续上线，题材同质化背景下，制作水准与剧本质量成为决定口碑的关键因素。",
    category: "剧集更新",
    date: "2025-06-02",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20crime%20drama%20news%20photo%2C%20a%20magnifying%20glass%20and%20notes%20on%20a%20dark%20wooden%20desk%20under%20a%20warm%20lamp%2C%20investigative%20moody%20atmosphere%2C%20orange%20and%20deep%20shadow%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n9&orientation=landscape",
    content:
      "近期多部悬疑题材剧集陆续上线，市场一时颇为热闹。不过，在题材同质化明显的背景下，能否脱颖而出越来越取决于制作水准与剧本质量。观众对逻辑漏洞与套路化反转的容忍度明显降低，扎实的案件设计、合理的人物动机与精良的视听呈现成为基本要求。业内认为，悬疑剧的竞争已从题材红利转向精品化比拼，唯有真正用心的作品才能赢得口碑。",
  },
  {
    id: "n10",
    title: "美食综艺《美食奇遇记》第二季回归，寻味之旅再启程",
    summary: "口碑美食综艺《美食奇遇记》宣布第二季回归，本季将前往更多小众目的地，探寻地道风味与背后的故事。",
    category: "综艺热点",
    date: "2025-05-30",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20food%20show%20news%20photo%2C%20steaming%20local%20dishes%20on%20a%20rustic%20wooden%20table%20with%20warm%20evening%20light%2C%20appetizing%20cozy%20mood%2C%20warm%20orange%20and%20amber%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n10&orientation=landscape",
    content:
      "口碑美食综艺《美食奇遇记》正式宣布第二季回归。本季节目将继续以寻味中国大江南北为主线，前往更多小众目的地，记录街边小吃与地方经典菜肴背后的故事。制作团队表示，新一季在叙事上将更加注重人与食物的情感联结，希望通过一道道菜肴，展现不同地域的生活气息与文化底蕴。节目预计将于下月与观众见面。",
  },
  {
    id: "n11",
    title: "老牌演员陆沉舟谈表演：把每个角色都当成新的开始",
    summary:
      "老牌演员陆沉舟在近日的采访中分享了自己的表演心得，坦言每一次塑造角色都是一次重新出发，引发业内共鸣。",
    category: "明星八卦",
    date: "2025-05-28",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20interview%20news%20photo%2C%20an%20empty%20theater%20stage%20with%20a%20single%20warm%20spotlight%20and%20wooden%20floorboards%2C%20reflective%20artistic%20mood%2C%20warm%20orange%20and%20amber%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n11&orientation=landscape",
    content:
      "老牌演员陆沉舟在近日的一次深度采访中分享了自己的表演心得。他表示，无论演过多少角色，每一次塑造人物都是一次重新出发，都需要放下经验、回到角色的内心世界。谈及行业现状，他认为年轻演员最需要的不是捷径，而是耐心与积累。此番真诚的分享引发了业内外的广泛共鸣，不少观众留言表示，正是这份对表演的敬畏之心，让作品有了打动人心的力量。",
  },
  {
    id: "n12",
    title: "数据显示：观众对现实题材影视关注度持续上升",
    summary:
      "最新行业报告显示，现实题材影视作品的市场关注度持续上升，贴近生活的故事与真实的人物更易引发观众共鸣。",
    category: "行业观察",
    date: "2025-05-26",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20media%20report%20news%20photo%2C%20a%20warm%20modern%20office%20desk%20with%20charts%20on%20a%20tablet%20and%20coffee%2C%20professional%20analytical%20mood%2C%20orange%20and%20cream%20tones%2C%20clean%20high%20detail%20composition%2C%20no%20text%20no%20letters&width=800&height=600&seq=po18-news-n12&orientation=landscape",
    content:
      "最新发布的行业报告显示，现实题材影视作品的市场关注度持续上升。数据显示，贴近普通人生活的故事、真实可信的人物塑造，更容易引发观众的情感共鸣与讨论。报告指出，随着观众审美水平的提升，悬浮的设定与刻意的煽情正在失去吸引力，而有温度、有细节的现实叙事正成为新的口碑密码。这一趋势也促使更多创作者将目光投向身边的真实故事。",
  },
];